import React from 'react';
import { MapPin } from 'lucide-react';
const CITIES = ['Blanchard', 'Norman', 'Moore', 'Oklahoma City', 'Edmond', 'Yukon', 'Mustang', 'Chickasha', 'Shawnee', 'El Reno', 'Newcastle', 'Tuttle', 'Purcell'];
export function ServiceArea() {
  return <section id="service-area" className="py-24 bg-white relative overflow-hidden" data-id="element-197">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#1d3a63 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-198" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-199">
        <div className="max-w-4xl mx-auto bg-slate-50 rounded-2xl border border-slate-200 p-8 md:p-12 shadow-xl flex flex-col md:flex-row items-center gap-12" data-id="element-200">
          <div className="flex-1 text-center md:text-left" data-id="element-201">
            <div className="inline-flex items-center gap-2 text-accent font-bold uppercase tracking-wider mb-4" data-id="element-202">
              <MapPin className="h-5 w-5" data-id="element-203" />
              Blanchard & Surrounding Areas
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-slate-900 uppercase tracking-wide mb-6" data-id="element-204">
              Serving <span className="text-accent" data-id="element-205">Central Oklahoma</span>
            </h2>
            <p className="text-slate-600 text-lg mb-8" data-id="element-206">
              We bring our expert repair services directly to your doorstep
              across Cleveland County, Canadian County, Payne County, and
              beyond.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-207">
              {CITIES.map(city => <span key={city} className="px-4 py-2 rounded-full bg-white border border-slate-200 text-slate-700 text-sm font-medium shadow-sm" data-id="element-208">
                  {city}
                </span>)}
            </div>
          </div>

          <div className="w-full md:w-1/2 flex justify-center" data-id="element-209">
            <div className="relative w-full aspect-square max-w-sm rounded-full overflow-hidden border-4 border-slate-200 shadow-[0_0_50px_rgba(29,58,99,0.1)]" data-id="element-210">
              <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?q=80&w=800&auto=format&fit=crop" alt="Beautiful suburban home exterior in Oklahoma" className="w-full h-full object-cover" data-id="element-211" />
              <div className="absolute inset-0 bg-slate-900/10" data-id="element-212" />
              <MapPin className="h-16 w-16 text-accent absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 drop-shadow-lg" data-id="element-213" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}